// REASON: Portfolio routes are user-id-keyed at /portfolio/[user_id]; no
// /profile/[pubkey] route exists (T002 finding).
export function getProfileHref(userId: string): string {
  return `/portfolio/${userId}`;
}
